import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-base-station-line', title: t('services.list.7.title'), tags: [t('services.list.7.tags.0'), t('services.list.7.tags.1')], href: '/telecom-infrastructures' },
    { icon: 'ri-route-line', title: 'Fibre Optique', tags: ['Télécom', 'Réseaux'], href: '/telecom-fibre' },
    { icon: 'ri-tools-line', title: 'Maintenance NOC', tags: ['Télécom', 'Support'], href: '/telecom-maintenance' },
    { icon: 'ri-building-2-line', title: t('services.list.4.title'), tags: [t('services.list.4.tags.0'), t('services.list.4.tags.1')], href: '/autres-services' },
    { icon: 'ri-sun-line', title: t('services.list.0.title'), tags: [t('services.list.0.tags.0'), t('services.list.0.tags.1')], href: '/solutions' },
    { icon: 'ri-tools-line', title: t('services.list.1.title'), tags: [t('services.list.1.tags.0'), t('services.list.1.tags.1')], href: '/solutions' },
    { icon: 'ri-battery-charge-line', title: t('services.list.2.title'), tags: [t('services.list.2.tags.0'), t('services.list.2.tags.1')], href: '/solutions' },
    { icon: 'ri-dashboard-line', title: t('services.list.3.title'), tags: [t('services.list.3.tags.0'), t('services.list.3.tags.1')], href: '/solutions' },
    { icon: 'ri-computer-line', title: t('services.list.5.title'), tags: [t('services.list.5.tags.0'), t('services.list.5.tags.1')], href: '/autres-services' },
    { icon: 'ri-search-line', title: t('services.list.6.title'), tags: [t('services.list.6.tags.0'), t('services.list.6.tags.1')], href: '/autres-services' },
    { icon: 'ri-truck-line', title: t('services.list.8.title'), tags: [t('services.list.8.tags.0'), t('services.list.8.tags.1')], href: '/autres-services' },
  ];

  return (
    <section className="py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="relative h-full">
            <div className="grid grid-cols-2 auto-rows-fr gap-2 h-full">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Telecommunications%20tower%20with%20multiple%20antennas%20and%20microwave%20dishes%20against%20clear%20African%20sky%2C%20professional%20telecom%20infrastructure%20close-up%20photography%2C%20bright%20daylight%20with%20blue%20sky%20background%2C%20detailed%20cellular%20network%20equipment%20on%20steel%20structure&width=400&height=300&seq=svc-tel-tower-01&orientation=landscape"
                  alt="Tours de télécommunication"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://storage.helloreaddy.io/project_files/dd4db55e-adff-421a-ab07-f57f9542cdee/3e35acfa-88fb-4cf5-97a0-5eb3f17179fa_compressed_ChatGPT-Image-3-aot-2026-15_15_39.webp"
                  alt="Fibre optique"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="col-span-2 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Network%20operations%20center%20with%20team%20of%20Black%20African%20engineers%20monitoring%20large%20screens%20displaying%20telecom%20network%20maps%20and%20performance%20data%2C%20modern%20technology%20control%20room%20with%20professional%20workstations%2C%20blue%20ambient%20lighting%20and%20high-tech%20environment%20with%20dark-skinned%20technicians&width=800&height=280&seq=svc-tel-noc-01&orientation=landscape"
                  alt="NOC"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Black%20African%20construction%20workers%20and%20welders%20building%20steel%20metal%20structure%20for%20industrial%20telecom%20site%20in%20Africa%2C%20professional%20civil%20engineering%20and%20BTP%20workers%20with%20dark%20skin%20wearing%20safety%20helmets%20and%20vests%2C%20construction%20site%20with%20reinforced%20concrete%20and%20steel%20framework%2C%20bright%20daylight&width=400&height=300&seq=svc-btp-01&orientation=landscape"
                  alt="Génie civil et BTP"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Black%20African%20solar%20panel%20installation%20team%20working%20on%20African%20rooftop%2C%20dark-skinned%20renewable%20energy%20technicians%20in%20safety%20gear%20mounting%20photovoltaic%20modules%2C%20bright%20sunny%20day%20with%20blue%20sky%2C%20professional%20sustainable%20energy%20construction%20photography%20with%20African%20workers&width=400&height=300&seq=svc-solar-01&orientation=landscape"
                  alt={t('services.list.0.title')}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
          <div>
            <div className="inline-flex items-center border border-primary-300/60 rounded-full px-4 py-1.5 mb-6">
              <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">{t('services.badge')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 mb-6 leading-tight">
              {t('services.title')}
            </h2>
            <p className="text-foreground-600 text-lg leading-relaxed mb-10">
              {t('services.description')}
            </p>
            <div className="space-y-4">
              {services.map((service) => (
                <Link
                  key={service.title}
                  to={service.href}
                  className="group flex items-center gap-4 p-4 rounded-2xl bg-white border border-background-200/70 hover:border-primary-300/60 hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center shrink-0">
                    <i className={`${service.icon} text-primary-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-foreground-950 text-sm mb-1.5">
                      {service.title}
                    </div>
                    <div className="flex gap-2">
                      {service.tags.map((tag) => (
                        <span
                          key={tag}
                          className="inline-flex items-center border border-primary-200/70 rounded-full px-2.5 py-0.5 text-xs text-primary-700 font-medium"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="w-8 h-8 bg-background-100 rounded-full flex items-center justify-center group-hover:bg-primary-500 transition-colors shrink-0">
                    <i className="ri-arrow-right-line text-foreground-400 group-hover:text-background-950 w-4 h-4 flex items-center justify-center transition-colors"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}